import type { VariationComponent } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck({
    items = [],
}: VariationComponent): IntegrityStatus {
    if (!items.length) {
        return ["Primary Story is required."];
    }

    const [primaryStory] = items;

    const errors = [];

    if (!primaryStory.headline) {
        errors.push("Primary Story missing headline.");
    }

    return errors;
}
